import cn from 'classnames';
import Image from 'next/image';

type Item = {
  id: string;
  title: string;
};

type Props = {
  items: Item[];
  className?: string;
  img?: string;
};

export default function CooperateFeatures({ items, className, img }: Props) {
  return (
    <section className={cn('bg-secondary-10 py-20', className)}>
      <div className="max-w-8xl desktop:auto-cols-fr desktop:grid-flow-col desktop:grid-cols-2 desktop:px-8 mx-auto grid grid-cols-1 place-content-center items-center gap-12 px-4">
        <div
          className="desktop:h-full h-60 w-full bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${img})` }}
        ></div>
        <article className="desktop:py-10 mx-auto flex h-full flex-col items-start justify-start">
          <h3 className="text-title32 text-neutral-90 desktop:text-title42 mb-4 text-left font-bold">
            Tính năng nổi bật
          </h3>
          <ul className="text-neutral-80 space-y-6">
            {items.map((item) => (
              <li
                key={item.id}
                className="flex flex-row items-center space-x-3"
              >
                <div
                  className="relative mt-1 h-5 w-5 shrink-0
                "
                >
                  <Image
                    src="/static/icons/customer/CheckCircle.svg"
                    alt={item.title}
                    fill
                  />
                </div>
                <p className="text-body16 text-neutral-80 font-normal">
                  {item.title}
                </p>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </section>
  );
}
